/* -*- Mode: javascript; indent-tabs-mode: nil; c-basic-offset: 2 -*- */

(function() {
  'use strict';

  /*
   * sgToggleGrid - Convert the tiles of a grid to toggle buttons
   * @memberof SOGo.Common
   * @restrict attribute
   * @param {object} sgToggleGrid - the model of the source objects
   * @param {string} [sgToggleGridAttr] - the attribute that specifies if an object is enabled (toggled)
   * @ngInject
   * @example:

    <md-grid-list md-cols="7" md-row-height="1:1"
                  sg-toggle-grid="editor.event.repeat.days"
                  sg-toggle-grid-attr="day">..</md-grid-list>
  */
  function sgVariableScrollShrink() {
    return {
      restrict: 'C',
      link: link
    };

    function link(scope, element, attrs, ctrl) {
      console.debug('scroll shrink height = ' + element.prop('offsetHeight'));
    }
  }

  angular
    .module('SOGo.Common')
    .directive('sgVariableScrollShrink', sgVariableScrollShrink);
})();
